import { render, staticRenderFns } from "./StaffMembershipTable.vue?vue&type=template&id=6a727446&scoped=true&"
import script from "./StaffMembershipTable.vue?vue&type=script&lang=js&"
export * from "./StaffMembershipTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a727446",
  null
  
)

export default component.exports